import React from "react";
import { Redirect } from "react-router-dom";
import Context from "../../../Context";
import TemplateEditor from "../../Editor/TemplateEditor";
import BigError from "../../Misc/BigError";
import Blocker from "../../Misc/Blocker";
import TemplateTitle from "./TemplateTitle";
export default class TemplateEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      pending: false,
      doc: false,
      showEditor: false,
      currentTitle: "Новый",
      currentLink: "",
    };
  }
  componentDidMount() {
    this.load();
  }

  load = async () => {
    if (this.props.id) {
      this.setState({ pending: true });
      let doc = await this.context.api.q("/manual/get", {
        id: this.props.id,
      });
      this.setState({ doc });
      if (doc.id && String(doc.structure) === this.props.structure) {
        this.setState({
          showEditor: true,
          currentTitle: doc.label || "",
          currentLink: "",
        });
        this.showTitle();
      } else {
        this.setState({ notFound: true });
      }
      this.setState({ pending: false });
    } else {
      if (this.props.copyObjId) {
        this.setState({ pending: true });
        let doc = await this.context.api.q("/manual/get", {
          id: this.props.copyObjId,
        });
        if (doc.id) {
          doc.id = null;
          this.setState({
            doc,
            showEditor: true,
            currentTitle: doc.label || "",
            currentLink: "",
          });
          this.showTitle();
        } else {
          this.setState({ notFound: true });
        }
        this.setState({ pending: false });
      } else {
        this.setState({
          showEditor: true,
          currentTitle: "Новый",
          currentLink: "",
        });
        this.showTitle();
      }
    }
  };

  onTitleChange = (newTitle) => {
    this.setState({ currentTitle: newTitle });
  };

  showTitle = () => {
    const { currentTitle, doc } = this.state;

    this.context.titleAreaSet(
      <TemplateTitle
        editable={true}
        title={currentTitle}
        onTitleChange={this.onTitleChange}
      />
    );
    this.context.browserTitleSet(currentTitle);
  };

  onSave = async (editorState, html) => {
    let structure = this.props.structure;
    if (!structure || structure === "all") {
      this.context.toast("Необходимо выбрать раздел документации", "error");
      return;
    }

    let elem = document.createElement("div");
    elem.innerHTML = html;
    let text = elem.innerText;

    let type = this.props.id
      ? this.state.doc.type
      : this.context.getType(`public.${this.props.document}`);

    let result = await this.context.api.q("/manual/set", {
      id: this.props.id || null,
      content: editorState,
      rendered: html || null,
      data: text,
      label: this.state.currentTitle,
      structure: structure,
      type,
    });
    if (result !== false) {
      if (this.props.add && result.id) {
        this.setState({
          redirect: `/manual/${this.props.structure}/${result.id}/edit`,
        });
      }
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };
  onAutoSave = async (editorState, html) => {};
  onOpen = () => {
    let structure = this.props.structure;
    this.setState({ redirect: `/manual/${structure}/` });
  };
  onNew = () => {
    let structure = this.props.structure;

    let typecode = this.state.doc.typecode;
    if (typecode) {
      typecode = typecode.split(".").pop();
      console.log(`/manual/${structure}/${typecode}/add/`);
      if (!this.props.add) {
        this.setState({
          redirect: `/manual/${structure}/${typecode}/add/`,
        });
      }
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    if (this.state.notFound) {
      return (
        <BigError
          title={"Документ не найден"}
          message={`Не удалось получить информацию о документе #${this.props.id}`}
        />
      );
    }
    return (
      <>
        <Blocker on={this.state.pending}>
          {this.state.showEditor ? (
            <TemplateEditor
              key={this.props.id}
              add={this.props.add}
              content={this.state.doc.content}
              onOpen={this.onOpen}
              onNew={this.onNew}
              onSave={this.onSave}
              onAutoSave={this.onAutoSave}
            />
          ) : null}
        </Blocker>
      </>
    );
  }
}
